import { styledByTheme } from "../../../../../../themes/architecture/styled-by-theme";
import {DepositSideMenuItemCasino777Box} from "./deposit-side-menu-item.casino777.box";
import {DepositSideMenuItemDefaultBox} from "./deposit-side-menu-item.default.box";



export const DepositSideMenuItemBox = styledByTheme(DepositSideMenuItemDefaultBox)
    .forCasino777(DepositSideMenuItemCasino777Box)
    .apply();
